import { Component, Input, OnInit } from '@angular/core';
import { QuestionGroup } from 'src/app/interfaces/question';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'question-group-card',
  templateUrl: './question-group-card.component.html',
  styleUrls: ['./question-group-card.component.scss'],
})
export class QuestionGroupCardComponent implements OnInit {

  constructor(public userService: UserService) { }

  @Input() questionGroup: Pick<QuestionGroup, 'image' | 'title' | 'description'> | undefined;

  ngOnInit() {}

}
